import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tp-footer-2" }
const _hoisted_2 = { class: "tp-footer-main pt-70 pb-55" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xl-3 col-lg-4 col-md-6" }
const _hoisted_6 = { class: "tp-footer-widget tp-footer-2-col-1 mb-30" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tp-footer-widget-logo mb-20 tp-header-logo" }, [
  /*#__PURE__*/_createElementVNode("a", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/lms_website/images/unix_logo-sm.jpg",
      alt: ""
    })
  ])
], -1 /* HOISTED */)
const _hoisted_8 = { class: "tp-footer-widget-content" }
const _hoisted_9 = { class: "tp-footer-contact" }
const _hoisted_10 = { class: "tp-footer-btn" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "11",
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.71533 1L13 5.28471L8.71533 9.56941",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 5.28467H12.88",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_12 = { class: "col-xl-3 col-lg-4 col-md-6 col-sm-6" }
const _hoisted_13 = { class: "tp-footer-widget tp-footer-2-col-2 mb-30" }
const _hoisted_14 = { class: "tp-footer-widget-title mb-15" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-footer-widget-link\"><ul><li><a href=\"about.html\">About Us</a></li><li><a href=\"course-with-filter.html\">Courses</a></li><li><a href=\"blog-standard.html\">News &amp; Blogs</a></li><li><a href=\"become-instructor.html\">Become a Teacher</a></li><li><a href=\"event.html\">Events</a></li><li><a href=\"contact.html\">Contact</a></li></ul></div>", 1)
const _hoisted_16 = { class: "col-xl-3 col-lg-4 col-md-6 col-sm-6" }
const _hoisted_17 = { class: "tp-footer-widget tp-footer-2-col-3 mb-30" }
const _hoisted_18 = { class: "tp-footer-widget-title mb-15" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-footer-widget-link\"><ul><li><a href=\"student-profile.html\">Students</a></li><li><a href=\"university-admission-overview.html\">Addmition</a></li><li><a href=\"university-leadership.html\">Faculty &amp; Staffs</a></li><li><a href=\"#\">Media Relations</a></li><li><a href=\"#\">Alumni</a></li><li><a href=\"university-schedule.html\">Visit</a></li></ul></div>", 1)
const _hoisted_20 = { class: "col-xl-3 col-lg-4 col-md-6" }
const _hoisted_21 = { class: "p-footer-widget tp-footer-2-col-4 mb-30" }
const _hoisted_22 = { class: "tp-footer-widget-title mb-20" }
const _hoisted_23 = { class: "tp-footer-contact" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "tp-footer-contact-mail mb-10" }
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<span><svg width=\"18\" height=\"16\" viewBox=\"0 0 18 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 5C1 2.2 2.6 1 5 1H13C15.4 1 17 2.2 17 5V10.6C17 13.4 15.4 14.6 13 14.6H5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M13 5.40039L10.496 7.40015C9.672 8.05607 8.32 8.05607 7.496 7.40015L5 5.40039\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M1 11.4004H5.8\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M1 8.19922H3.4\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></span>", 1)
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "tp-footer-bottom" }
const _hoisted_30 = { class: "container" }
const _hoisted_31 = { class: "row align-items-center" }
const _hoisted_32 = { class: "col-lg-3 col-md-4" }
const _hoisted_33 = { class: "tp-footer-bottom-social" }
const _hoisted_34 = ["href"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-facebook-f" }, null, -1 /* HOISTED */)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["href"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-tiktok" }, null, -1 /* HOISTED */)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["href"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-twitter" }, null, -1 /* HOISTED */)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = ["href"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-linkedin-in" }, null, -1 /* HOISTED */)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["href"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-youtube" }, null, -1 /* HOISTED */)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "col-lg-6 col-md-5" }
const _hoisted_50 = { class: "tp-footer-copyright text-start text-md-center" }
const _hoisted_51 = { class: "col-lg-3 col-md-3" }
const _hoisted_52 = { class: "text-start text-md-end" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.datavalue.solutions",
  class: "text-primary",
  target: "_blank"
}, "Data Value", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" footer-area-start "),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", null, _toDisplayString($setup.lms_website.__($setup.lms_website.settings_list?.about_text)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_router_link, {
                        to: {name:'helpdesk'},
                        class: "tp-btn-round"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.lms_website.__('Contact Us')) + " ", 1 /* TEXT */),
                          _hoisted_11
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h4", _hoisted_14, _toDisplayString($setup.lms_website.__('About')), 1 /* TEXT */),
                  _hoisted_15
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("h4", _hoisted_18, _toDisplayString($setup.lms_website.__('Quick links')), 1 /* TEXT */),
                  _hoisted_19
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("h4", _hoisted_22, _toDisplayString($setup.lms_website.__('Our Newsletter')), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Got Questions? Call us')), 1 /* TEXT */),
                    _createElementVNode("a", {
                      href: `tel:${$setup.lms_website.settings_list?.contact_phone}`
                    }, _toDisplayString($setup.lms_website.settings_list?.contact_phone), 9 /* TEXT, PROPS */, _hoisted_24)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("a", {
                      href: `mailto:${$setup.lms_website.settings_list?.contact_email}`
                    }, [
                      _hoisted_27,
                      _createTextVNode(" " + _toDisplayString($setup.lms_website.settings_list?.contact_email), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_26)
                  ]),
                  _createElementVNode("div", {
                    class: "tp-footer-contact-mail mb-20",
                    innerHTML: $options.formatTextWithNewLines($setup.lms_website.__($setup.lms_website.settings_list?.address))
                  }, null, 8 /* PROPS */, _hoisted_28),
                  _createCommentVNode("                <div class=\"tp-footer-app\">"),
                  _createCommentVNode("                  <a href=\"#\"><img src=\"/assets/lms_website/website-assets/img/footer/google-play.jpg\" alt=\"\"></a>"),
                  _createCommentVNode("                  <a href=\"#\"><img src=\"/assets/lms_website/website-assets/img/footer/apple-store.jpg\" alt=\"\"></a>"),
                  _createCommentVNode("                </div>")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  ($setup.lms_website.settings_list.facebook_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $setup.lms_website.settings_list.facebook_link,
                        target: "_blank"
                      }, _hoisted_36, 8 /* PROPS */, _hoisted_34))
                    : _createCommentVNode("v-if", true),
                  ($setup.lms_website.settings_list.tiktok_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: $setup.lms_website.settings_list.tiktok_link,
                        target: "_blank"
                      }, _hoisted_39, 8 /* PROPS */, _hoisted_37))
                    : _createCommentVNode("v-if", true),
                  ($setup.lms_website.settings_list.twitter_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: $setup.lms_website.settings_list.twitter_link,
                        target: "_blank"
                      }, _hoisted_42, 8 /* PROPS */, _hoisted_40))
                    : _createCommentVNode("v-if", true),
                  ($setup.lms_website.settings_list.linkedin_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        href: $setup.lms_website.settings_list.linkedin_link,
                        target: "_blank"
                      }, _hoisted_45, 8 /* PROPS */, _hoisted_43))
                    : _createCommentVNode("v-if", true),
                  ($setup.lms_website.settings_list.youtube_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 4,
                        href: $setup.lms_website.settings_list.youtube_link,
                        target: "_blank"
                      }, _hoisted_48, 8 /* PROPS */, _hoisted_46))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('© 2024 UNIX. All rights reserved.')), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createTextVNode(_toDisplayString($setup.lms_website.__('Powered By')) + " ", 1 /* TEXT */),
                  _hoisted_53
                ])
              ]),
              _createCommentVNode("                    <div class=\"col-lg-3 col-md-3\">"),
              _createCommentVNode("                        <div class=\"header-bottom__lang-2 text-start text-md-end\">"),
              _createCommentVNode("                            <ul>"),
              _createCommentVNode("                                <li>"),
              _createCommentVNode("                                    <a id=\"header-bottom__lang-toggle\" href=\"javascript:void(0)\">"),
              _createCommentVNode("                                        <span>EN</span>"),
              _createCommentVNode("                                        <span>"),
              _createCommentVNode("                                       <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"6\" viewBox=\"0 0 10 6\" fill=\"none\">"),
              _createCommentVNode("                                          <path d=\"M1 1L5 5L9 1\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"),
              _createCommentVNode("                                       </svg>"),
              _createCommentVNode("                                    </span>"),
              _createCommentVNode("                                    </a>"),
              _createCommentVNode("                                    <ul class=\"header-bottom__lang-submenu-2\">"),
              _createCommentVNode("                                        <li>"),
              _createCommentVNode("                                            <a href=\"#\">Arabic</a>"),
              _createCommentVNode("                                        </li>"),
              _createCommentVNode("                                        <li>"),
              _createCommentVNode("                                            <a href=\"#\">Spanish</a>"),
              _createCommentVNode("                                        </li>"),
              _createCommentVNode("                                        <li>"),
              _createCommentVNode("                                            <a href=\"#\">Mandarin</a>"),
              _createCommentVNode("                                        </li>"),
              _createCommentVNode("                                    </ul>"),
              _createCommentVNode("                                </li>"),
              _createCommentVNode("                            </ul>"),
              _createCommentVNode("                        </div>"),
              _createCommentVNode("                    </div>")
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" footer-area-end ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}